import React, { useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { themeCSSVariables } from '@/utils/theme';

interface ThemeProviderProps {
  children: React.ReactNode;
  theme: 'light' | 'dark';
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, theme }) => {
  useEffect(() => {
    const root = document.documentElement;
    const variables = themeCSSVariables[theme];
    
    // Apply CSS variables to document root
    Object.entries(variables).forEach(([property, value]) => {
      root.style.setProperty(property, value);
    });
    
    // Add theme class to body for additional styling
    document.body.className = document.body.className.replace(/theme-\w+/, '');
    document.body.classList.add(`theme-${theme}`);

    // Set data-theme attribute so [data-theme="dark"] CSS selectors work
    document.documentElement.setAttribute('data-theme', theme);
    
  }, [theme]);

  return (
    <div className={`theme-${theme}`}>
      {children}
    </div>
  );
};

export default ThemeProvider; 